import { toast } from 'react-toastify';
import ReportApi from '../services/report.service';
import { actionOption } from './actionOption.utils';
import { getLinkRefNumbers, isDataReady } from './dataReady.utils';

const reportApi = new ReportApi();

window.addEventListener('offline', () => {
	toast.error('You seem to be offline.', {
		position: 'bottom-center',
		hideProgressBar: true,
	});
});

export const generateApprovedConsentTemplates = async (
	setConsentRequestData,
	isPurposeNeeded = true
) => {
	await reportApi
		.getApprovedConsentTemplates()
		.then((res) => {
			isPurposeNeeded
				? setConsentRequestData(res.data?.body)
				: setConsentRequestData(res.data?.body.consentTemplateRequest);
		})
		.catch((err) => {
			setConsentRequestData([]);
		});
};

export const generateConsents = async (customerId, setConsentData) => {
	await toast
		.promise(reportApi.getConsentsByCustomerId(customerId), {
			pending: 'Fetching consents...',
			error: 'Failed to fetch consent data!',
		})
		.then((res) => {
			const consents = res.data?.body?.customerConsents;
			const newConsents = consents.map((obj) => {
				return { ...obj, visible: false };
			});
			setConsentData(newConsents);
		})
		.catch((err) => {
			setConsentData([]);
		});
};

export const submitConsentRequest = async (consentDetails, setRedirectUrl) => {
	await toast
		.promise(reportApi.postConsentRequest(consentDetails), {
			pending: 'Submitting consent request...',
			error: 'Failed to submit consent request!',
			success: 'Consent request submitted successfully!',
		})
		.then((res) => {
			// console.log(res.data.body.url);
			setRedirectUrl(res.data.body.url);
		});
};

export const generateConsentsRequests = async (
	customerId,
	requestDate,
	setRequestData
) => {
	if (customerId || requestDate) {
		await toast
			.promise(reportApi.getConsentRequests(customerId, requestDate), {
				pending: 'Fetching consent requests...',
				error: 'Failed to fetch consent requests!',
			})
			.then((res) => {
				const requestData = res.data?.body?.consentDetails;
				const newRequestData = requestData?.map((rowData) => {
					return {
						...rowData,
						dataLabel: actionOption(
							rowData.consentStatus,
							rowData.fetchType,
							// rowData.refreshed,
							rowData.requestSessionId
						),
					};
				});
				setRequestData(newRequestData);
			})
			.catch((err) => {
				setRequestData([]);
			});
	} else {
		toast.info('Enter either Customer ID or Consent Request Date!');
	}
};

export const generateConsentStatus = (rowData, requestData, setRequestData) => {
	// console.log('rowData consent status: ', rowData);
	toast
		.promise(
			reportApi.getConsentStatus(rowData.consentHandle, rowData.custId),
			{
				pending: 'Getting consent status...',
				success: 'Consent status updated successfully!',
				error: 'Failed to update consent status!',
			},
			{
				hideProgressBar: true,
				autoClose: 1000,
			}
		)
		.then((res) => {
			//iterate through entire requestData, only change that matches consentHandle
			const updatedRequestData = requestData.map((item) =>
				item.consentHandle === rowData.consentHandle
					? {
						...item,
						consentStatus: res.data?.body?.consentStatus,
						dataLabel: actionOption(
							res.data?.body?.consentStatus,
							rowData.fetchType,
							// true,
							rowData.requestSessionId
						),
						refreshed: true,
					}
					: item
			);
			setRequestData(updatedRequestData);
		})
		.catch((err) => { });
};

export const fetchFIData = (
	consentDetails,
	requestData,
	setRequestData,
	setFiRequestData
) => {
	toast
		.promise(
			reportApi.postFiRequest(consentDetails),
			{
				pending: 'Sending data request...',
				success: 'Data Request sent successfully!',
				error: 'Failed to send data request!',
			},
			{
				hideProgressBar: true,
				autoClose: 1000,
			}
		)
		.then((res) => {
			setFiRequestData(res.data?.body);
			//consentDetails IS rowData
			const updatedRequestedData = requestData.map((item) =>
				item.consentHandle === consentDetails.consentHandle
					? {
						...item,
						dataLabel: 'Refresh Data Status',
						sessionId: res.data?.body?.sessionId,
					}
					: item
			);
			setRequestData(updatedRequestedData);
		})
		.catch((err) => { });
};

export const generateDataStatus = (
	rowData,
	fiRequestData,
	requestData,
	setRequestData,
	setAccounts,
	setShowFailedAccounts
) => {
	toast
		.promise(
			reportApi.getDataStatus(
				fiRequestData.consentId
					? fiRequestData.consentId
					: rowData.requestConsentId,
				fiRequestData.sessionId
					? fiRequestData.sessionId
					: rowData.requestSessionId,
				rowData.consentHandle,
				rowData.custId
			),
			{
				pending: 'Getting data status...',
				// success: 'Data status updated successfully!',
				error: 'Failed to update data status!',
			},
			{
				hideProgressBar: true,
				autoClose: 1000,
			}
		)
		.then((res) => {
			const accountsData = res.data?.body?.accounts;
			let isPartial = false;
			let isPending = false;
			let linkRefArray = [];
			const fiRequestStatus = res.data?.body?.fiRequestStatus;
			if (
				(accountsData && fiRequestStatus === 'FAILED') ||
				(accountsData && fiRequestStatus === 'PENDING')
			) {
				isPartial = true;
				linkRefArray = getLinkRefNumbers(accountsData);
				if (fiRequestStatus === 'PENDING') {
					isPending = true;
				}
			}
			// linkRefArray = getLinkRefNumbers(accountsData); //TODO: to be removed

			const status =
				(accountsData && fiRequestStatus === 'FAILED') ||
					(accountsData && fiRequestStatus === 'PENDING')
					? isDataReady(accountsData)
					: fiRequestStatus;
			console.log('Status: ', status);
			const updatedRequestData = requestData.map((item) =>
				item.consentHandle === rowData.consentHandle
					? {
						...item,
						dataStatus: status,
						dataLabel:
							status === 'READY' || status === 'PARTIAL'
								? 'View Data'
								: item.dataLabel,
						isPartial: isPartial,
						linkRefArray: linkRefArray,
						isPending: isPending,
					}
					: item
			);
			if (status === 'FAILED') {
				generateAccountDataById(rowData?.requestConsentId, setAccounts);
				setShowFailedAccounts(true);
			}
			switch (status) {
				case 'READY':
					toast.info('Data is ready to view!');
					break;
				case 'FAILED':
					toast.error('Fetching FI Data Failed!');
					break;
				case 'PARTIAL':
					toast.info('Partial FI Data ready!');
					break;
				default:
					toast.info('Data is not ready!');
			}
			setRequestData(updatedRequestData);
		})
		.catch((err) => { });
};

const isNullFiData =  (fiData) => {
	return fiData === "Account data not found." || fiData[0]?.fiObjects?.some(element => element === null)
}

export const generateFIData = (
	fiRequestData,
	rowData,
	requestData,
	setRequestData
) => {
	toast
		.promise(
			reportApi.getFIData(
				rowData.consentHandle,
				fiRequestData.sessionId
					? fiRequestData.sessionId
					: rowData.requestSessionId
			),
			{
				pending: 'Fetching FI data...'
			}
		)
		.then((res) => {
			if(isNullFiData(res.data?.body)){
				toast.error("Data not found")
				setRequestData(requestData)
			} else {
				const updatedRequestData = requestData.map((item) =>
					item.consentHandle === rowData.consentHandle
						? { ...item, fiData: res.data?.body, visible: true }
						: item
				);
				setRequestData(updatedRequestData);
			}
		})
		.catch((err) => {
			let apiErrorMessage = err?.response?.data?.errors?.[0]?.errorMsg || 'Fetching FI Data Failed!';
    
			if (apiErrorMessage.includes('Retention time is Over')) {
				const sessionIdMatch = apiErrorMessage.match(/sessionID. ([a-f0-9-]+)/i);
				if (sessionIdMatch) {
					apiErrorMessage = `Retention time is Over.`;
				}
			}
			toast.error(apiErrorMessage);
		 });
};

const fetchIndividualData = async (rowData, fiRequestData, linkRefArray) => {
	const promises = [];

	for (const linkRefObj of linkRefArray) {
		const apiCallPromise = reportApi.getFIData(
			rowData.consentHandle,
			fiRequestData.sessionId
				? fiRequestData.sessionId
				: rowData.requestSessionId,
			linkRefObj.linkRefNumber
		);
		promises.push(apiCallPromise);
	}

	const responses = await Promise.all(promises);

	const mergedData = responses.map((response) => response?.data?.body).flat();

	return mergedData;
};

export const generateIndividualFIData = (
	fiRequestData,
	rowData,
	requestData,
	setRequestData,
	linkRefArray
) => {
	fetchIndividualData(rowData, fiRequestData, linkRefArray)
		.then((mergedData) => {
			const updatedRequestData = requestData.map((item) =>
				item.consentHandle === rowData.consentHandle
					? { ...item, fiData: mergedData, visible: true }
					: item
			);
			setRequestData(updatedRequestData);
			// console.log(mergedData);
			// console.log(updatedRequestData);
		})
		.catch((err) => { });
};

export const generateFIDataPDF = (
	consentHandle,
	sessionId,
	linkRefNo,
	customerName
) => {
	toast
		.promise(reportApi.getFIDataPDF(consentHandle, sessionId, linkRefNo), {
			pending: 'Downloading PDF...',
			error: 'Retention time is Over',
		})
		.then((res) => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${customerName}_fiData.pdf`);
			document.body.appendChild(link);
			link.click();
		});
};

export const generateInsightsPDF = (consentHandle, sessionId, linkRefNo) => {
	toast
		.promise(
			reportApi.getFIDataReportPDF(consentHandle, sessionId, linkRefNo),
			{
				pending: 'Downloading Insights PDF...',
				error: 'Retention time is Over',
			}
		)
		.then((res) => {
			// console.log('blob pdf : ', new Blob([res.data]));
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'insights.pdf');
			document.body.appendChild(link);
			link.click();
		});
};

export const generateInsightsXLSX = (consentHandle, sessionId, linkRefNo) => {
	toast
		.promise(
			reportApi.getFIDataReportXLSX(consentHandle, sessionId, linkRefNo),
			{
				pending: 'Downloading Insights XLS...',
				error: 'Retention time is Over',
			}
		)
		.then((res) => {
			// console.log('blob xlsx: ', new Blob([res.data]));
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'insights.xlsx');
			document.body.appendChild(link);
			link.click();
		});
};

export const generateInsights = (consentHandle, sessionId, linkRefNo) => {
	// console.log('CONSENT HANDLE: ', consentHandle);
	// console.log('SESSION ID: ', sessionId);
	// console.log('LINK REF NO.: ', linkRefNo);

	return new Promise((resolve, reject) => {
		toast
			.promise(reportApi.getFIDataReport(consentHandle, sessionId, linkRefNo), {
				pending: 'Getting account insights...',
				error: 'Retention time is Over',
			})
			.then((res) => {
				// console.log(res.data?.body);
				resolve(res.data?.body);
			})
			.catch((err) => {
				// console.log(err);
				reject(err);
			});
	});
};

export const generateMetrics = (setMetrics) => {
	reportApi
		.getDashboardMetrics()
		.then((res) => {
			// console.log(res.data);
			setMetrics(res.data);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generatePFMMetrics = (setMetrics) => {
	reportApi
		.getPFMMetrics()
		.then((res) => {
			// console.log(res.data);
			setMetrics(res.data);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateGraphData = (inputData, setGraphData) => {
	if (inputData) {
		reportApi
			.getGraphData(inputData)
			.then((res) => {
				// console.log(res.data);
				setGraphData(res.data);
			})
			.catch((err) => {
				// console.log(err);
			});
	}
};

export const generateApprovedUserRoles = (
	setRolesOrPermissionGroupList,
	isPermissionGroup = false
) => {
	return toast
		.promise(reportApi.getApprovedUserRoles(), {
			pending: 'Fetching user roles...',
			error: 'Error fetching user roles!',
		})
		.then((res) => {
			// console.log(res);
			if (isPermissionGroup)
				setRolesOrPermissionGroupList(res.data.body.permissionGroups);
			else setRolesOrPermissionGroupList(res.data.body.userRoles);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const submitNewUser = (inputData) => {
	toast
		.promise(reportApi.createNewUser(inputData), {
			pending: 'Creating new user...',
			// error: 'Error creating new user!',
			// success: 'Successfully created new user!',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateApprovedUsers = (setApprovedUsers) => {
	toast
		.promise(reportApi.getApprovedUsers(), {
			pending: 'Getting approved users...',
			error: 'Error getting approved users!',
		})
		.then((res) => {
			// console.log(res);
			setApprovedUsers(res.data.body.manageUsers);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateApprovedUserDetails = (
	userId,
	setApprovedUserDetails,
	approvedUserList,
	setApprovedUserList
) => {
	toast
		.promise(reportApi.getApprovedUserDetails(userId), {
			pending: 'Fetching user details...',
			error: 'Error fetching user details!',
		})
		.then((res) => {
			const userDetails = res.data.body.manageUser;

			//Change one single object
			const updatedUserDetails = { ...userDetails, visible: true };
			setApprovedUserDetails(updatedUserDetails);

			//Change array of objects to maintain state
			const updatedApprovedUserList = approvedUserList.map((userObj) =>
				userObj.userId === userId ? updatedUserDetails : userObj
			);
			setApprovedUserList(updatedApprovedUserList);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const removeApprovedUser = (userId) => {
	toast
		.promise(reportApi.deleteApprovedUser(userId), {
			pending: 'Creating delete request for the user...',
			// error: 'Error creating delete request!',
		})
		.then((res) => {
			// console.log(res);
			res.data?.errors?.map((err) => {
				return toast.error(err.errorMsg);
			});
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateUsers = (setUsers) => {
	toast
		.promise(reportApi.getUsers(), {
			pending: 'Fetching users...',
			error: 'Error fetching users!',
		})
		.then((res) => {
			// console.log(res);
			setUsers(res.data.body.manageUsers);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const approveUserAction = (userId, setUsers) => {
	toast
		.promise(reportApi.postUserApproval(userId), {
			pending: 'Approving user action...',
			// error: 'Error approving user action!',
			// success: 'Action approved successfully!',
		})
		.then((res) => {
			// console.log(res);
			generateUsers(setUsers);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const removeUser = (userId, setUsers) => {
	toast
		.promise(reportApi.deleteUser(userId), {
			pending: 'Deleting user action request...',
			error: 'Error deleting user action request!',
			success: 'Deleted user action request successfully!',
		})
		.then((res) => {
			// console.log(res);
			generateUsers(setUsers);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateUserDetails = (
	userId,
	setUserDetails,
	userList,
	setUserList
) => {
	toast
		.promise(reportApi.getUserDetails(userId), {
			pending: 'Fetching user details...',
			error: 'Error fetching user details!',
		})
		.then((res) => {
			const userDetails = res.data.body.manageUser;

			//Change one single object
			const updatedUserDetails = { ...userDetails, visible: true };
			setUserDetails(updatedUserDetails);

			//Change array of objects to maintain state
			const updatedUserList = userList.map((userObj) =>
				userObj.userId === userId ? updatedUserDetails : userObj
			);
			setUserList(updatedUserList);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const removeApprovedUserRole = (roleName) => {
	toast
		.promise(reportApi.deleteApprovedUserRole(roleName), {
			pending: 'Creating delete request for the user role...',
			error: 'Error creating delete request!',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateApprovedUserRoleDetails = (
	roleName,
	setApprovedUserRoleDetails,
	approvedUserRoleList,
	setApprovedUserRoleList
) => {
	toast
		.promise(reportApi.getApprovedUserRoleDetails(roleName), {
			pending: 'Fetching user role details...',
			error: 'Error fetching user role details!',
		})
		.then((res) => {
			const userRoleDetails = res.data.body.userRole;

			//Change one single object
			const updatedUserRoleDetails = { ...userRoleDetails, visible: true };
			setApprovedUserRoleDetails(updatedUserRoleDetails);

			//Change array of objects to maintain state
			const updatedApprovedUserRoleList = approvedUserRoleList.map(
				(userObj) => {
					return userObj.roleName === roleName
						? updatedUserRoleDetails
						: userObj;
				}
			);
			setApprovedUserRoleList(updatedApprovedUserRoleList);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateUserRoles = (setUserRoles) => {
	toast
		.promise(reportApi.getUserRoles(), {
			pending: 'Fetching user roles...',
			error: 'Failed fetching list of user roles!',
		})
		.then((res) => {
			// console.log(res.data.body.userRoles);
			setUserRoles(res.data.body.userRoles);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const approveUserRoleAction = (roleName, setUserRoles) => {
	toast
		.promise(reportApi.postUserRoleApproval(roleName), {
			pending: 'Approving user role action...',
			error: 'Error approving user role action!',
			// success: 'Action approved successfully!',
		})
		.then((res) => {
			// console.log(res);
			generateUserRoles(setUserRoles);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const removeUserRole = (roleName, setUserRoles) => {
	toast
		.promise(reportApi.deleteUserRole(roleName), {
			pending: 'Deleting user role action request...',
			error: 'Error deleting user role action request!',
			success: 'Deleted user role action request successfully!',
		})
		.then((res) => {
			// console.log(res);
			generateUserRoles(setUserRoles);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateUserRoleDetails = (
	roleName,
	setUserRoleDetails,
	userRoleList,
	setUserRoleList
) => {
	toast
		.promise(reportApi.getUserRoleDetails(roleName), {
			pending: 'Fetching user role details...',
			error: 'Error fetching user role details!',
		})
		.then((res) => {
			const userRoleDetails = res.data.body.userRole;

			//Change one single object
			const updatedUserRoleDetails = { ...userRoleDetails, visible: true };
			setUserRoleDetails(updatedUserRoleDetails);

			//Change array of objects to maintain state
			const updatedApprovedUserRoleList = userRoleList.map((userObj) => {
				return userObj.roleName === roleName ? updatedUserRoleDetails : userObj;
			});
			setUserRoleList(updatedApprovedUserRoleList);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const submitNewUserRole = (inputData) => {
	toast
		.promise(reportApi.createNewUserRole(inputData), {
			pending: 'Creating new user role...',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateConsentTemplates = (setTemplates) => {
	toast
		.promise(reportApi.getConsentTemplates, {
			pending: 'Fetching consent templates...',
			error: 'Failed to fetch consent templates!',
		})
		.then((res) => {
			// console.log(res);
			setTemplates(res.data.body.consentTemplateRequest);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const submitTemplateCreationRequest = (templateDetails) => {
	toast
		.promise(reportApi.postConsentTemplate(templateDetails), {
			pending: 'Submitting...',
			error: 'Error creating consent template!',
			// success: 'Consent template created successfully!',
		})
		.then((res) => {
			// console.log(res.data);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateConsentTemplateDetails = (
	templateName,
	setTemplateDetails,
	templateList,
	setTemplateList
) => {
	toast
		.promise(reportApi.getConsentTemplateDetails(templateName), {
			pending: 'Fetching template details...',
			error: 'Error fetching template details!',
		})
		.then((res) => {
			const templateDetails = res.data.body.consentTemplateRequest;

			//Change one single object
			const updatedTemplateDetails = { ...templateDetails, visible: true };
			setTemplateDetails(updatedTemplateDetails);

			// (why) -> update list passed (approved list is not always passed here, only naming is as such)
			//Change array of objects to maintain state
			const updatedTemplateList = templateList.map((templateObj) => {
				return templateObj.templateName === templateName
					? updatedTemplateDetails
					: templateObj;
			});
			setTemplateList(updatedTemplateList);
		})
		.catch((err) => {
			// console.log(err);
		});
};
export const generateApprovedConsentTemplateDetails = (
	templateName,
	setTemplateDetails,
	templateList,
	setTemplateList
) => {
	toast
		.promise(reportApi.getApprovedConsentTemplateDetails(templateName), {
			pending: 'Fetching template details...',
			error: 'Error fetching template details!',
		})
		.then((res) => {
			const templateDetails = res.data.body.consentTemplateRequest;

			//Change one single object
			const updatedTemplateDetails = { ...templateDetails, visible: true };
			setTemplateDetails(updatedTemplateDetails);

			//Change array of objects to maintain state
			const updatedTemplateList = templateList.map((templateObj) => {
				return templateObj.templateName === templateName
					? updatedTemplateDetails
					: templateObj;
			});

			setTemplateList(updatedTemplateList);
		})
		.catch((err) => {
			// console.log(err);
		});
};
export const approveTemplateAction = (templateName, setTemplates) => {
	toast
		.promise(reportApi.postTemplateApproval(templateName), {
			pending: 'Approving consent template action...',
			// error: 'Error approving consent template action!',
			// success: 'Action approved successfully!',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
			generateConsentTemplates(setTemplates);
		})
		.catch((err) => {
			// console.log(err);
		});
};
export const removeConsentTemplate = (templateName, setTemplates) => {
	toast
		.promise(reportApi.deleteTemplate(templateName), {
			pending: 'Deleting consent template request...',
			// error: 'Error deleting consent template request!',
			// success: 'Deleted consent template request successfully!',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
			generateConsentTemplates(setTemplates);
		})
		.catch((err) => {
			// console.log(err);
		});
};
export const removeApprovedConsentTemplate = (templateName, setTemplates) => {
	toast
		.promise(reportApi.deleteApprovedTemplate(templateName), {
			pending: 'Deleting consent template...',
			// error: 'Error deleting consent template!',
			// success: 'Deleted consent template successfully!',
		})
		.then((res) => {
			// console.log(res);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
			generateApprovedConsentTemplates(setTemplates, false);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const modifyApprovedUserRole = (inputData) => {
	toast
		.promise(reportApi.editApprovedUserRole(inputData), {
			pending: 'Submitting changes...',
			// error: 'Error making changes to the user role!',
			// success: 'Successfully modified user role!',
		})
		.then((res) => {
			// console.log(res.data);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const modifyApprovedUser = (inputData) => {
	toast
		.promise(reportApi.editApprovedUser(inputData), {
			pending: 'Submitting changes...',
			// error: 'Error making changes to the user!',
			// success: 'Successfully modified user!',
		})
		.then((res) => {
			// console.log(res.data);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const modifyApprovedConsentTemplate = (templateDetails) => {
	toast
		.promise(reportApi.editConsentTemplate(templateDetails), {
			pending: 'Submitting...',
			// error: 'Error editing consent template!',
			// success: 'Consent template edited successfully!',
		})
		.then((res) => {
			// console.log(res.data);
			res.data.errors
				? res.data?.errors?.map((err) => {
					return toast.error(err.errorMsg);
				})
				: toast.success(res.data.body);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateFIUConfigDetails = () => {
	reportApi
		.getConfigObject()
		.then((res) => {
			// console.log(res.data);
			sessionStorage.setItem('config', res.data);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generatePFMGraphData = (inputData, setGraphData) => {
	reportApi
		.getPFMGraphData(inputData)
		.then((res) => {
			// console.log(res.data);
			setGraphData(res.data);
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const generateAccountDataById = (consentId, setAccounts) => {
	reportApi
		.getAccountsByConsentId(consentId)
		.then((res) => {
			const accounts = res?.data?.body?.ConsentDetail?.Accounts;
			setAccounts(accounts);
		})
		.catch((err) => {
			console.log(err);
		});
};

export const generateSahamatiTemplateRules = async (setSahamatiCodeList) => {
    await reportApi
        .getSahamatiTemplateRulesCodes()
        .then((res) => {
            const dropdownOptions = res.data?.body.fairUseTemplateList.map(code => ({
                label: code,
                value: code
            }));
            setSahamatiCodeList(dropdownOptions);
        })
        .catch((err) => {
            console.error("Error fetching Sahamati codes:", err);
            setSahamatiCodeList([]);
        });
};


export const modifyUserPassword = (inputData, setShowModal) => {
	return new Promise((resolve, reject) => {
		toast
			.promise(reportApi.editUserPassword(inputData), {
				pending: 'Submitting edit request...',
			})
			.then((res) => {
				if (res.data.errors) {
					toast.error(res.data.body);
					reject(res.data.body);
				} else {
					toast.success(res.data.body);
					setShowModal(false);
					resolve();
				}
			})
			.catch((err) => {
				toast.error(err.response.data);
				reject(err.response.data);
			});
	});
};
export const getFipPerformanceData = async (range, setFipPerformanceData) => {
	await toast
		.promise(reportApi.getFipPerformanceScore(range), {
			pending: 'Fetching data...',
			error: 'Failed to fetch data!',
		})
		.then((res) => {
			if (res && res.data) {
				if (res.data !== 'Internal Server Error') {
					setFipPerformanceData(res.data);
				}
			}
		})
		.catch((err) => { });
};

export const getFipList = (dispatch) => {
	reportApi
		.getFipList()
		.then((res) => {
			if (res && res?.data?.body) {
				dispatch(res?.data?.body);
			}
		})
		.catch((err) => {
			// console.log(err);
		});
};

export const getClassifiedTransactions = async (transactions) => {
	return await toast 
		.promise(reportApi.getClassifiedTransactions(transactions), {
			pending: 'Classifying transactions...',
			error: 'Failed to classify transactions'
		})
		.then((res) => {
			return res.data.transactions || [];
		})
		.catch((err) => {
			return [];
		});
}

export const fetchTemplateData = async (code, setFieldValue, templateData, setIsLoading, setLoadingError, setFieldsPrefilledFromAPI, setOriginalValues, mapDataRangeUnit) => {
    if (!code) return;

    setIsLoading(true);
    setLoadingError(null);
    
    try {
        const reportApi = new ReportApi();
        const response = await reportApi.getSahamatiTemplateRules(code);
        const data = response.data.body;

        setFieldValue('fiType', data.fiTypes);
        
        setFieldValue('consentType', data.consentTypes || []);
        setFieldValue('frequency', data.fetchType || 'ONETIME');

        if (data.frequencyUnit && data.frequencyValue) {
            setFieldValue('frequencyPeriod.unit', data.frequencyUnit);
            setFieldValue('frequencyPeriod.value', data.frequencyValue);
        }

        if (data.DataFilter && data.DataFilter.length > 0) {
            const filter = data.DataFilter[0];
            setFieldValue('dataFilter.type', filter.type);
            setFieldValue('dataFilter.operator', filter.operator);
            setFieldValue('dataFilter.value', filter.value);
        }

        setFieldValue('dataLife.unit', data.dataLifeUnit);
        setFieldValue('dataLife.value', data.dataLifeValue);

        if (data.consentExpiryUnit === 'NA' || data.dataRangeEndUnit === '') {
            setFieldValue('consentExpiry.unit', ''); 
            setFieldValue('consentExpiry.isValidUnit', false); 
            setOriginalValues(prev => ({
                ...prev,
                consentExpiryNA: true
            }));
        } else {
            setFieldValue('consentExpiry.unit', data.consentExpiryUnit);
            setFieldValue('consentExpiry.isValidUnit', true); 
            setOriginalValues(prev => ({
                ...prev,
                consentExpiry: data.consentExpiryValue,
                consentExpiryNA: false
            }));
        }
        setFieldValue('consentExpiry.value', data.consentExpiryValue === 0 ? '' : data.consentExpiryValue);

        const dataRangeUnit = mapDataRangeUnit(data.dataRangeStartValue);
        setFieldValue('dataRange.unit', dataRangeUnit);
		//To Sync both consent expiry and data range end value and unit
        setFieldValue('dataRange.value', data.consentExpiryValue === 0 ? '' : data.consentExpiryValue);
		setFieldValue('dataRangeEndUnit', data.consentExpiryUnit);
		
		if (data.dataRangeEndUnit === 'NA' || data.dataRangeEndUnit === '') {
			setFieldValue('dataRangeEndUnit', '');
			setFieldValue('dataRange.isValidValueUnit', false);
			setOriginalValues(prev => ({
				...prev,
				dataRangeEndUnitNA: true
			}));
		} else {
			setFieldValue('dataRangeEndUnit', data.dataRangeEndUnit);
			setFieldValue('dataRange.isValidValueUnit', true);
			setOriginalValues(prev => ({
				...prev,
				dataRangeEndUnit: data.dataRangeEndUnit,
				dataRangeEndUnitNA: false
			}));
		}

        setFieldValue('businessPurpose', data.useCaseCategory);
        
        if (templateData?.purpose) {
            const matchingPurpose = templateData.purpose.find(p => p.code === data.purpose.toString());
            if (matchingPurpose) {
                setFieldValue('purpose', matchingPurpose);
            }
        }

        setFieldsPrefilledFromAPI(true);
        const originalValuesFromAPI = {
            consentExpiry: data.consentExpiryValue,
            dataLife: data.dataLifeValue,
            dataRange: data.dataRangeEndValue,
			dataRangeStartValue: mapDataRangeUnit(data.dataRangeStartValue),
            frequencyPeriod: data.frequencyValue
        };
        setOriginalValues(originalValuesFromAPI);
        
    } catch(error) {
        console.error('Error fetching template data:', error);
        setLoadingError('Failed to load template data. Please try again.');
    } finally {
        setIsLoading(false);
    }
};
